import { startListening } from './handlers/gestures/eventReceiver';

export function initialize() {
  startListening();
}
